
const kijshopCd = ':kijshopCd';
const shopOrderId = ':shopOrderId';
const orderId = ':orderId';
const staffPkId = ':staffPkId';
const orders = `/${kijshopCd}/orders`;
const oneStopOrders = `/${kijshopCd}/one-stop`
const olcOrders = `/${kijshopCd}/ods`
const ordersPreparation = orders + `/${shopOrderId}/preparation`;
/* カート画面 ワンストップ用 */
const oneStopOrdersPreparation = oneStopOrders + `/${shopOrderId}/preparation`;
const ordersItemPage = ordersPreparation + `/${orderId}`;
const oneStopOrdersItemPage = oneStopOrdersPreparation + `/${orderId}`;
/* カート画面 OLC用 */
const olcOrdersPreparation = olcOrders + `/${shopOrderId}/preparation`;
const olcOrdersItemPage = olcOrdersPreparation + `/${orderId}`;
const olcOrdersAdd = olcOrdersPreparation + '/add';
const ordersPrint = ordersItemPage + '/print';
const ordersAdd = ordersPreparation + '/add';
const oneStopOrdersAdd = oneStopOrdersPreparation + '/add';
const ordersEdit = ordersItemPage + '/add';
const oneStopOrdersEdit = oneStopOrdersItemPage + '/add';
const olcOrdersEdit = olcOrdersItemPage + '/add';
const ordersLayout = ordersItemPage + '/layout';
const ordersRetouch = ordersPreparation + '/retouch';
const uploadManager = orders + '/upload-manager';
const config = `/${kijshopCd}/config`;
const configSystem = config + '/system';
const configAccount = config + '/account';
const configPc = config + '/pc';
const staff = `/${kijshopCd}/staff`;
const staffMngEnable = `/${kijshopCd}/staff-mng/enable`;
const staffMngMailChange = `/${kijshopCd}/staff-mng/mail-change`;
const staffMngPasswordChange = `/${kijshopCd}/staff-mng/password-change`;
const staffPasswordRegister = `/${kijshopCd}/staff-password-register`;
const shop = `/${kijshopCd}/shop`;
const cFolderOrder = `/${kijshopCd}/c-folder-order`;
const cloudFolder = `/${kijshopCd}/cloud-folder`;
/* まとめてプリント(SIFT) */
const imageId = ':imageId';
const print = `/${kijshopCd}/print`; // 注文一覧
const printOrder = `${print}/${shopOrderId}/preparation`; // カート
const printOrderAddInfo = `${printOrder}/add/info`; // 注文作成 
const printToneCorrection = `${printOrder}/toneCorrection`; // 色補正
const printOrderAddImageUpload = `${printOrder}/add/image`; // 注文作成 画像アップロード
const printOrderAddOrderSelect = `${printOrder}/add/order-select`; // 商品選択
const printOrderSelectImage = `${printOrder}/select-image`; // 商品選択
const printOrderTrimming = `${printOrder}/trim/${orderId}/${imageId}`; // 注文作成 商品選択
const uploadManagerForPrint = print + '/upload-manager-for-print';


// react-router に PathParam があるので注意
export type PathParams = {
  kijshopCd: string,
  shopOrderId: string,
  orderId: string,
  staffPkId: string,
  imageId: string,
};

const replace = (path: string, param: Partial<PathParams>) => {
  let str = path;
  if (param.kijshopCd) {
    str = str.replace(kijshopCd, param.kijshopCd);
  }
  if (param.shopOrderId) {
    str = str.replace(shopOrderId, param.shopOrderId);
  }
  if (param.orderId) {
    str = str.replace(orderId, param.orderId);
  }
  if (param.staffPkId) {
    str = str.replace(staffPkId, param.staffPkId);
  }
  if (param.imageId) {
    str = str.replace(imageId, param.imageId);
  }
  return str;
};

export const RoutingPath = {
  // - ログイン -
  // -- 店舗ログイン --
  login: '/login',
  // -- スタッフログイン --
  staffLogin: '/staff/login',
  // - 注文 -
  // -- 注文一覧 --
  orders,
  // - まとめてプリント注文一覧 --
  print,
  // -- 注文作成準備 -
  ordersPreparation,
  // -- 注文作成準備(ワンストップ) -
  oneStopOrdersPreparation,
  // -- 注文作成準備(OLC) -
  olcOrdersPreparation,
  // -- 注文画像印刷 --
  ordersPrint,
  // -- 注文作成画面 --
  ordersAdd,
  // -- 注文作成画面(ワンストップ) --
  oneStopOrdersAdd,
  // -- 注文作成画面(OLC) --
  olcOrdersAdd,
  // -- 注文編集画面 --
  ordersEdit,
  // -- 注文編集画面(ワンストップ) --
  oneStopOrdersEdit,
  // -- 注文編集画面(OLC) --
  olcOrdersEdit,
  // -- レイアウト --
  ordersLayout,
  // -- レタッチ --
  ordersRetouch,
  // -- Upload Manager --
  uploadManager,
  // - config -
  // -- システム設定 --
  configSystem,
  // -- アカウント設定 --
  configAccount,
  // -- PC設定 --
  configPc,
  // - debug -
  debug: '/debug',
  // -- ui --
  debugUi: '/debug/ui',
  // -- dialog --
  debugDialog: '/debug/dialog',
  // -- xml parse --
  debugXml: '/debug/xml',
  // -- 完成画像生成(デバッグ専用/画面内導線なし) --
  debugCompImage: '/debug/comp-image',
  // -- クラウドフォルダ店舗一覧 --
  shop,
  // -- クラウドフォルダ注文一覧 --
  cFolderOrder,
  // -- クラウドフォルダセッション移行 --
  cloudFolder,
  // まとめてプリント
  // -- オーダー作成画面 --
  printOrder,
  printOrderAddInfo, // 情報入力
  printOrderAddImageUpload, // 画像アップロード
  printOrderAddOrderSelect, // 注文選択
  printOrderSelectImage, // 画像選択
  printOrderTrimming, // トリミング
  printToneCorrection, //色補正
  uploadManagerForPrint, //Upload Manager For Print
  // - パス変換用 -
  cnv: {
    orders: (param: { kijshopCd: string }) => replace(orders, param),
    print:(param: { kijshopCd: string }) => replace(print, param),
    shop: (param: { kijshopCd: string }) => replace(shop, param),
    cFolderOrder: (param: { kijshopCd: string }) => replace(cFolderOrder, param),
    ordersPreparation: (param: { kijshopCd: string, shopOrderId: string }) => replace(ordersPreparation, param),
    oneStopOrdersPreparation: (param: { kijshopCd: string, shopOrderId: string }) => replace(oneStopOrdersPreparation, param),
    olcOrdersPreparation: (param: { kijshopCd: string, shopOrderId: string }) => replace(olcOrdersPreparation, param),
    ordersPrint: (param: { kijshopCd: string, shopOrderId: string, orderId: string }) => replace(ordersPrint, param),
    ordersAdd: (param: { kijshopCd: string, shopOrderId: string }) => replace(ordersAdd, param),
    oneStopOrdersAdd: (param: { kijshopCd: string, shopOrderId: string }) => replace(oneStopOrdersAdd, param),
    olcOrdersAdd: (param: { kijshopCd: string, shopOrderId: string }) => replace(olcOrdersAdd, param),
    ordersEdit: (param: { kijshopCd: string, shopOrderId: string, orderId: string }) => replace(ordersEdit, param),
    oneStopOrdersEdit: (param: { kijshopCd: string, shopOrderId: string, orderId: string }) => replace(oneStopOrdersEdit, param),
    olcOrdersEdit: (param: { kijshopCd: string, shopOrderId: string, orderId: string }) => replace(olcOrdersEdit, param),
    ordersLayout: (param: { kijshopCd: string, shopOrderId: string, orderId: string }) => replace(ordersLayout, param),
    ordersRetouch: (param: { kijshopCd: string, shopOrderId: string }) => replace(ordersRetouch, param),
    uploadManager: (param: { kijshopCd: string }) => replace(uploadManager, param),
    configSystem: (param: { kijshopCd: string }) => replace(configSystem, param),
    configAccount: (param: { kijshopCd: string }) => replace(configAccount, param),
    configPc: (param: { kijshopCd: string }) => replace(configPc, param),
    staff: (param: { kijshopCd: string }) => replace(staff, param),
    staffMngEnable: (param: { kijshopCd: string }) => replace(staffMngEnable, param),
    staffMngMailChange: (param: { kijshopCd: string }) => replace(staffMngMailChange, param),
    staffMngPasswordChange: (param: { kijshopCd: string }) => replace(staffMngPasswordChange, param),
    staffPasswordRegister: (param: { kijshopCd: string }) => replace(staffPasswordRegister, param),
    printOrderAddOrderSelect: (param: { kijshopCd: string, shopOrderId: string }) => replace(printOrderAddOrderSelect, param),
    printOrder: (param: { kijshopCd: string, shopOrderId: string }) => replace(printOrder, param),
    printOrderAddInfo: (param: { kijshopCd: string, shopOrderId: string }) => replace(printOrderAddInfo, param),
    printOrderAddImageUpload: (param: { kijshopCd: string, shopOrderId: string }) => replace(printOrderAddImageUpload, param),
    printOrderSelectImage: (param: { kijshopCd: string, shopOrderId: string }) => replace(printOrderSelectImage, param),
    printToneCorrection: (param: { kijshopCd: string, shopOrderId: string }) => replace(printToneCorrection, param),
    printOrderTrimming: (param: { kijshopCd: string, shopOrderId: string, orderId: string, imageId: string }) => replace(printOrderTrimming, param),
    uploadManagerForPrint: (param: { kijshopCd: string }) => replace(uploadManagerForPrint, param),
  },
  // - スタッフ管理 -
  staff,
  // - ウィザード -
  // -- 店舗パスワード忘れ (管理者ログイン画面→パスワードをお忘れの方はこちら) --
  adminPasswordReset: '/admin/password-reset',
  // -- スタッフパスワード忘れ (スタッフログイン画面→パスワードをお忘れの方はこちら) --
  staffPasswordReset: '/staff/password-reset',
  // -- スタッフ管理機能有効 (システム設定→店舗設定→スタッフ管理機能ON) --
  staffMngEnable: staffMngEnable,
  // -- スタッフ管理 メールアドレス変更 (システム設定→店舗設定→店舗管理メールアドレス→変更) --
  staffMngMailChange: staffMngMailChange,
  // -- スタッフ管理 パスワード変更 (システム設定→店舗設定→店舗パスワード→変更) --
  staffMngPasswordChange: staffMngPasswordChange,
  // -- スタッフパスワード登録 (スタッフログイン→仮会員の場合表示) --
  staffPasswordRegister: staffPasswordRegister,
};
